import { RouterProvider } from 'react-router-dom';
import { AppProviders } from '@/app/providers/AppProviders';
import { router } from '@/app/router/router';
import { ChunkErrorBoundary } from '@/app/router/ChunkErrorBoundary';
import { useBackButton } from '@/modules/native/useBackButton';
import '@/modules/device/stores/rssi.store';

const NativeShell = () => {
  useBackButton();
  return null;
};

export const App = () => (
  <AppProviders>
    <NativeShell />
    <ChunkErrorBoundary>
      <RouterProvider router={router} />
    </ChunkErrorBoundary>
  </AppProviders>
);
